import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionPaymentsService } from '../services/construction-payment.service';
import { toast } from 'sonner';

export function useConstructionPaymentClaims(companyId: string, projectId?: string) {
  const query = useQuery({
    queryKey: ['construction-payment-claims', companyId, projectId],
    queryFn: () => ConstructionPaymentsService.getClaims(companyId, projectId),
    enabled: !!companyId,
  });

  const summaryQuery = useQuery({
    queryKey: ['construction-payment-summary', companyId, projectId],
    queryFn: () => ConstructionPaymentsService.getSummary(companyId, projectId),
    enabled: !!companyId,
  });

  return {
    claims: query.data || [],
    summary: summaryQuery.data,
    isLoading: query.isLoading || summaryQuery.isLoading,
  };
}

export function useConstructionPaymentClaimDetail(id?: string) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['construction-payment-claims', 'detail', id],
    queryFn: () => ConstructionPaymentsService.getClaimDetail(id!),
    enabled: !!id,
  });

  const updateStatusMutation = useMutation({
    mutationFn: ({ status, userId }: { status: string; userId: string }) => 
      ConstructionPaymentsService.updateClaimStatus(id!, status, userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-payment-claims'] });
      queryClient.invalidateQueries({ queryKey: ['construction-payment-claims', 'detail', id] });
      toast.success('Cập nhật trạng thái thanh toán thành công');
    },
  });

  return {
    claim: query.data,
    isLoading: query.isLoading,
    updateStatus: updateStatusMutation.mutateAsync,
    isUpdating: updateStatusMutation.isPending,
  };
}
